import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { DepartmentList } from '../models';
import { DepartmentService } from './department.service';


@Injectable({
	providedIn: 'root'
})
export class DepartmentListResolverService  {

	constructor(
		private departmentService: DepartmentService
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DepartmentList[]> {
		return this.departmentService.getList();
	}
}
